import { Inject, Injectable } from '@angular/core';
import { PlatformService } from '@app/modules/shared/services/platform-service';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class UrlHelper {
  apiUrl = '';
  idpUrl = '';
  frontendUrl = '';

  constructor(@Inject(PlatformService) private platformService: PlatformService) {
    if (!environment.production) {
      this.apiUrl = 'http://localhost:4300';
      this.idpUrl = 'https://localhost:44362';
      this.frontendUrl = 'http://localhost:4200';
      return;
    }

    if (this.platformService.isBrowser()) {
      this.apiUrl = window.location.protocol + '//' + window.location.host;
      this.idpUrl = window.location.protocol + '//' + window.location.host;
      this.frontendUrl = window.location.protocol + '//' + window.location.host;
    } else {
      this.apiUrl = process.env.url;
      this.idpUrl = process.env.url;
      this.frontendUrl = process.env.url;
    }
  }
}
